import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {UrlBuilderService} from '../../../../../../services/url-builder.service';
import {WpService} from '../../../../../../services/wp.service';
import {WPUserArray} from '../../../../../../types/WPUserArray';

@Component({
  selector: 'app-search-content-summary',
  templateUrl: './search-content-summary.component.html',
  styleUrls: ['./search-content-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class SearchContentSummaryComponent {
  public date = input<string>();
  public modified = input<string>();
  public author = input<WPUserArray[]>();
  public authorName = input<string>();
  public factChecker = input<string>();
  public sources = input<string>();

  public publishDateFull = computed<string>(() => this.wpService.getFormattedDate(this.date(), 'full'));
  public updateDateFull = computed<string>(() => this.wpService.getFormattedDate(this.modified(), 'full'));
  public authorToDisplay = computed<WPUserArray[]>(() =>
    this.author()
      ? this.author().map((authorItem) => {
          return {
            ...authorItem,
            routerLink: this.urlBuilder.CreateAuthorRouterLink(authorItem.nickname),
          };
        })
      : null,
  );

  constructor(
    public urlBuilder: UrlBuilderService,
    private wpService: WpService,
  ) {}
}
